import React from "react";

export default function AllSportsIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
            <rect width="15.908" height="15.908" transform="translate(0.092 0)" fill="rgba(255,255,255,0.6)" opacity="0"/>
            <g transform="translate(0)">
                <g fill="none" stroke="rgba(255,255,255,0.87)" strokeWidth="1.15">
                    <rect width="7" height="7" rx="1" stroke="none"/>
                    <rect x="0.575" y="0.575" width="5.85" height="5.85" rx="0.425" fill="none"/>
                </g>
                <g transform="translate(0 9)" fill="none" stroke="rgba(255,255,255,0.87)" strokeWidth="1.15">
                    <rect width="7" height="7" rx="1" stroke="none"/>
                    <rect x="0.575" y="0.575" width="5.85" height="5.85" rx="0.425" fill="none"/>
                </g>
                <g transform="translate(8.9)" fill="none" stroke="rgba(255,255,255,0.87)" strokeWidth="1.15">
                    <rect width="7" height="7" rx="1" stroke="none"/>
                    <rect x="0.575" y="0.575" width="5.85" height="5.85" rx="0.425" fill="none"/>
                </g>
                <g transform="translate(8.9 9)" fill="none" stroke="rgba(255,255,255,0.87)" strokeWidth="1.15">
                    <rect width="7" height="7" rx="1" stroke="none"/>
                    <rect x="0.575" y="0.575" width="5.85" height="5.85" rx="0.425" fill="none"/>
                </g>
            </g>
        </svg>
    );
}
